import { Component, OnInit, inject, output, DOCUMENT, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PreferencesService, UserPreferences } from '@services/preferences.service';

@Component({
  selector: 'app-modal-user-preferences',
  imports: [TranslateModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './modal-user-preferences.component.html',
})
export class ModalUserPreferencesComponent implements OnInit {
  activeTab: 'language' | 'accessibility' = 'language';

  requestClose = output<void>();

  private preferencesService = inject(PreferencesService);
  private translateService = inject(TranslateService);
  private document = inject(DOCUMENT);

  // Préférences actuelles en cours d'édition
  currentPreferences: UserPreferences = {
    boldText: false,
    uppercaseText: false,
    dyslexicMode: false,
    language: 'fr',
  };

  // Sauvegarde des préférences initiales pour permettre l'annulation
  private originalPreferences: UserPreferences = {
    boldText: false,
    uppercaseText: false,
    dyslexicMode: false,
    language: 'fr',
  };

  ngOnInit() {
    // Charger les préférences actuelles
    const snapshot = this.preferencesService.getPreferencesSnapshot();
    this.currentPreferences = { ...snapshot };
    this.originalPreferences = { ...snapshot };
    // Appliquer les classes au body
    this.applyClassesToBody();
  }

  setActiveTab(tab: 'language' | 'accessibility') {
    this.activeTab = tab;
  }

  closeModal() {
    this.requestClose.emit();
  }

  savePreferences() {
    // Sauvegarder les préférences
    this.preferencesService.save(this.currentPreferences);
    this.originalPreferences = { ...this.currentPreferences };
    this.closeModal();
  }

  onLanguageChange(language: string) {
    this.currentPreferences.language = language;
    this.applyPreference('language', language);
  }

  onBoldTextChange(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    this.currentPreferences.boldText = checked;
    this.applyPreference('boldText', checked);
  }

  onUppercaseTextChange(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    this.currentPreferences.uppercaseText = checked;
    this.applyPreference('uppercaseText', checked);
  }

  onDyslexicModeChange(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    this.currentPreferences.dyslexicMode = checked;
    this.applyPreference('dyslexicMode', checked);
  }

  private applyPreference(key: keyof UserPreferences, value: any) {
    // Appliquer la préférence en temps réel pour la preview

    if (key === 'language') {
      this.translateService.use(value as string);
    }

    // Appliquer les classes au body pour la preview
    this.applyClassesToBody();
  }

  private applyClassesToBody() {
    const body = this.document.body;

    // Gérer les classes d'accessibilité pour la preview
    if (this.currentPreferences.boldText) {
      body.classList.add('boldText');
    } else {
      body.classList.remove('boldText');
    }

    if (this.currentPreferences.uppercaseText) {
      body.classList.add('uppercaseText');
    } else {
      body.classList.remove('uppercaseText');
    }

    if (this.currentPreferences.dyslexicMode) {
      body.classList.add('dyslexicMode');
    } else {
      body.classList.remove('dyslexicMode');
    }
  }

  onCancel() {
    // Remettre les préférences comme elles étaient
    this.currentPreferences = { ...this.originalPreferences };

    // Réappliquer les anciennes préférences
    this.applyPreference('language', this.originalPreferences.language);
    // applyPreference appelle déjà applyClassesToBody()

    this.closeModal();
  }
}
